import {Space, Typography} from "antd"

export const SearchResultsHeader = ({ title, externalLink = null, button = null }) => {

  return(
    <div className="boxStyle">
      <Space direction="vertical">
        <Typography.Title>Search results for <Typography.Text type="warning" italic>{title}</Typography.Text>{externalLink ?
          <a href={externalLink}>External Link</a> : ''}
        </Typography.Title>
        {button}
      </Space>
    </div>
  )
}